module.exports = __webpack_public_path__ + "static/media/temp_13.95da48b3.jpg";